import { cn } from "@/lib/utils";

const SectionCard = ({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <section
      className={cn(
        "lg:max-w-screen-xl md:mx-auto px-5 py-10 lg:px-[90px] lg:py-20",
        className
      )}
      style={style}
    >
      {children}
    </section>
  );
};

export default SectionCard;
